import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HeadService } from '../../../../services/head.service';
import { CustomerService } from '../../../../services/customer.service';
import { LanguageService } from '../../../../services/language/language.service';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'account-discount',
  templateUrl: './account-discount.component.html',
  styleUrls: ['./account-discount.component.scss'],
  imports: [TranslatePipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountDiscountComponent implements OnInit {
  private headService = inject(HeadService);
  private destroyRef = inject(DestroyRef);
  protected customerService = inject(CustomerService);
  private languageService = inject(LanguageService);

  ngOnInit(): void {
    this.setMeta();
  }

  private setMeta(): void {
    this.languageService.getTranslation('account_discount.my_discounts').pipe(
      takeUntilDestroyed(this.destroyRef)
    ).subscribe({
      next: text => {
        this.headService.setMeta({ title: text, description: text });
      }
    });
  }
}
